module.exports = __webpack_public_path__ + "img/penilaian.63fd31a2.png";